import React from "react";

import "./styles.css";

/**
 * @function NoTransactionsView
 * @returns {React.Component}
 * @exported true
 * @description This is shown when there aren't any transactions that match the users search criteria.
 * @example
 * <NoTransactionsView />
 */
export default function NoTransactionsView(props) {
    return (
        <div className="text-center no-transactions-view">
            <p>No transactions match your search criteria.</p>
        </div>
    )
}
